import React from 'react';

type ButtonProps = {
  text: string;
  bgColor?: string;
  borderColor?: string;
  fontColor?: string;
  fontSize?: string;
  hoverBgColor?: string;
  hoverFontColor?: string;
  hoverBorderColor?: string;
  width?: string;
  height?: string;
  radius?: number;
  // for submit btn
  typeOfBtn?: string;
  // for icon
  icon?: React.ReactNode;
  disable?: boolean
};

const Button = ({
  typeOfBtn,
  text,
  bgColor = '',
  borderColor = 'border-BADBlue',
  fontColor = 'text-BADBlue',
  fontSize = 'text-base',
  hoverBgColor = 'bg-BAMPink',
  hoverFontColor = 'text-BAWhite',
  hoverBorderColor = 'border-BAMPink',
  width = 'w-[100%]',
  height = 'h-auto',
  radius = 6,
  icon,
  disable=false,
}: ButtonProps) => {
  const border = borderColor === '' ? '' : `border ${borderColor}`;
  const hoverBgColorStr = `hover:${hoverBgColor}`;
  const hoverBorderColorStr =
    hoverBorderColor === '' ? '' : `hover:${hoverBorderColor}`;
  const hoverFontColorStr = `hover:${hoverFontColor}`;
  // for submit btn
  const addType = typeOfBtn ? 'submit' : undefined;
  const disableCursor = disable ? 'opacity-50 cursor-not-allowed' : '';

  return (
    <button
      className={`${bgColor} ${fontSize} ${fontColor} ${border} ${hoverBgColorStr} ${hoverBorderColorStr} ${hoverFontColorStr} ${width} ${height} font-normal rounded-[${radius}px] ${disableCursor}`}
      type={addType}
      disabled={disable}
    >
      <div className="flex flex-row text-center items-center justify-center">
        {icon && <span className="mr-2">{icon}</span>}
        <p className="px-2">{text}</p>
      </div>
    </button>
  );
};

export default Button;